import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks'; import PageLoader from '../../../../../components/PageLoader';
import GlobalBranchComponent from '../components/global-branch.component';
import { selectGlobalBranchesQueryItems } from '../../../../../redux/global-iship-cloud/global-branches/selector';
import { globalBranches } from '../../../../../redux/global-iship-cloud/global-branches/action';

const GlobalBranch = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalBranchesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    branch,
    setBranch
  ] = useState<any>({})

  const fetchRecordById = () => {
    dispatch(globalBranches.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-branches/fetch-detail`, entity: 'globalBranches', jsonData:
      {
        Context: {},
        Records: [
          {
            "GlobalBranchId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchRecordById()
      }
    }, [])

  useEffect(
    () => {
      if (isQuery) {
        setBranch(queryItems?.result?.items)
      }
    }, [isQuery])

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setBranch({ ...branch, [field]: event });
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      dispatch(globalBranches.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-branches`, entity: 'globalBranches', jsonData:
        {
          "Context": {},
          Records: [
            branch
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(globalBranches.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-branches`, entity: 'globalBranches', jsonData:
        {
          "Context": {
          },
          Records: [
            branch
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = async () => {
    navigate(-1)
  }

  return (
    <>
      {queryItems?.isLoading ? <PageLoader /> :
        <GlobalBranchComponent
          branch={branch}
          handleFormSubmit={handleFormSubmit}
          back={back}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
        />}
    </>
  )

}

export default GlobalBranch;